import React from 'react';
import { Box } from '@honda-canada/design-system-react';
import { Helmet } from 'react-helmet-async';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';

import { useSitecoreLayoutService } from '../../../apiHooks';

const Features = ({ path }) => {
  const {
    response: layoutServiceRespone,
    pageMetaData,
    placeholderName,
    isFetching,
    hasError,
  } = useSitecoreLayoutService(path);

  if (!layoutServiceRespone || isFetching || hasError) return null;
  const currentMeta = pageMetaData.reduce((acc, meta) => {
    acc[meta.name] = meta.content;
    return acc;
  }, {});

  const pageTitle = layoutServiceRespone?.sitecore?.route?.fields?.pageTitle?.value || currentMeta.title;

  return (
    <Box pb="xl">
      {pageTitle && (
        <Helmet>
          <title>{pageTitle}</title>
        </Helmet>
      )}
      {currentMeta?.description && (
        <Helmet>
          <meta name="description" content={currentMeta.description} />
        </Helmet>
      )}
      <Placeholder name={placeholderName} rendering={layoutServiceRespone.sitecore.route} />
    </Box>
  );
};

export default Features;
